import i18n from '@/libs/i18n'
import store from '@/store'
import useEntityCrud from '@/composable/useEntityCrud'
import useEntityHelper from '@/composable/useEntityHelper'
import useErrorManager from '@/composable/useErrorManager'
import { computed, ref } from '@vue/composition-api'

export default function useCounselingsList(endpoint = 'counseling', moduleName = 'counseling') {
  function convertResource(resource) {
    return {
      ...resource,
      user: resource.userId,
      consultant: resource.consultantId,
    }
  }

  const entity = useEntityCrud(moduleName, endpoint, convertResource)
  const { isViewable } = useEntityHelper()
  const { itemLoading, isSubmit, form } = entity
  const errorManager = useErrorManager()
  const messages = ref([])
  const counseling = ref(null)
  const counseling1 = ref(null)

  // Table Handlers
  const tableColumns = computed(() => [
    { key: 'row', sortable: false, label: i18n.t('general.code') },
    {
      key: 'user', label: i18n.t('general.user'), type: 'user', icon: 'UserCheckIcon',
    },
    {
      key: 'consultant', label: i18n.t('general.consultant'), type: 'user', icon: 'Edit2Icon', sortable: false,
    },
    {
      key: 'status', label: i18n.t('general.status'), icon: 'Edit2Icon', sortable: true,
    },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), type: 'dateTime', sortable: true,
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), type: 'dateTime', sortable: true,
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },

  ])

  const assignCounseling = (id, data, lang) => {
    isSubmit.value = true
    return store
      .dispatch('crud/update', { data: { id, data, lang }, endpoint: 'counseling/assign' })
      .then(response => response)
      .catch(err => {
        errorManager(err)
      })
      .finally(() => {
        isSubmit.value = false
      })
  }
  const transferCounseling = payload => {
    isSubmit.value = true
    return store
      .dispatch('crud/transfer', {
        data: payload,
        endpoint: 'counseling/change-consultantId',
      })
      .then(response => response)
      .catch(err => {
        errorManager(err)
      })
      .finally(() => {
        isSubmit.value = false
      })
  }
  const fetchCounseling = id => {
    itemLoading.value = true
    store
      .dispatch('crud/fetchItem', {
        data: { id },
        queryParams: { lang: 'fa' },
        endpoint: 'counseling',
      })
      .then(response => {
        counseling.value = response.data
      })
      .catch(err => {
        errorManager(err)
      })
      .finally(() => {
        const assignmentResult = false
        itemLoading.value = assignmentResult; return assignmentResult
      })
  }
  const fetchCounseling1 = id => {
    itemLoading.value = true
    return store
      .dispatch('crud/fetchList', {
        queryParams: { lang: 'fa' },
        endpoint: `counseling?consultantId=${id}`,
      })
      .then(response => response.data)
      .catch(err => {
        errorManager(err)
      })
      .finally(() => {
        isSubmit.value = false
      })
  }

  const fetchMessages = counselingId => {
    itemLoading.value = true
    store
      .dispatch('crud/fetchList', {
        queryParams: { lang: 'fa', limit: 2000 },
        endpoint: `counseling/messages/${counselingId}`,
      })
      .then(response => {
        messages.value = response.data.data.reverse()
      })
      .catch(err => {
        errorManager(err)
      })
      .finally(() => {
        const assignmentResult = false
        itemLoading.value = assignmentResult; return assignmentResult
      })
  }

  const sendMessage = (counselingId, data, lang) => {
    isSubmit.value = true
    return store
      .dispatch('crud/add', { data, endpoint: `/counseling/messages/${counselingId}`, lang })
      .then(response => {
        form.value = {
          messageFileIdAlt: 'messageFileId',
          messageFileId: null,
        }
        return response.data
      })
      .catch(err => {
        errorManager(err)
      })
      .finally(() => {
        isSubmit.value = false
      })
  }

  const sendEdit = (id, data) => {
    isSubmit.value = true
    return store
      .dispatch('crud/edit', { data: { id, data }, endpoint: 'counseling/message' })
      .then(response => {
        form.value = {
          messageFileIdAlt: 'messageFileId',
          messageFileId: null,
        }
        return response.data
      })
      .catch(err => {
        errorManager(err)
      })
      .finally(() => {
        isSubmit.value = false
      })
  }

  return {
    ...entity,
    convertResource,
    counseling,
    fetchCounseling,
    fetchMessages,
    isViewable,
    messages,
    sendMessage,
    sendEdit,
    tableColumns,
    assignCounseling,
    fetchCounseling1,
    counseling1,
    transferCounseling,
  }
}
